import React from "react";
import { components } from "react-select";
import AsyncSelect from "react-select/async";

const Option = (props) => (
  <div>
    <components.Option {...props}>
      <i 
        className={`fas ${props.isSelected ? 'fa-check-square' : 'fa-square'}`}
        style={{ marginRight: 8, color: props.isSelected ? '#007bff' : '#ccc' }}
      />
      {props.label}
    </components.Option>
  </div>
);

const MultiValueRemove = (props) => (
  <components.MultiValueRemove {...props}>
    <i className="fas fa-times" style={{ fontSize: '0.75rem' }} />
  </components.MultiValueRemove>
);

const InputSelectMultiCustom = ({
  name,
  placeholder,
  optionsData,
  stateSelected,
  isDisabled = false,
  isLoading = false,
  id,
  loadOptions = () => {},
  handleOnChange = () => {},
}) => {
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <i className="fas fa-angle-down font-size-18 text-color-cinza4 icon-down-select" />
    </components.DropdownIndicator>
  );

  return (
    <AsyncSelect
      isMulti
      value={stateSelected}
      name={id || name}
      id={id || name}
      components={{ 
        DropdownIndicator,
        Option,
        MultiValueRemove
      }}
      defaultOptions={optionsData}
      loadOptions={loadOptions}
      onChange={handleOnChange}
      isLoading={isLoading}
      loadingMessage={"Carregando..."}
      isDisabled={isDisabled}
      placeholder={placeholder}
      className="select-filter-custom"
      classNamePrefix="select-filter-custom"
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      noOptionsMessage={() => "Nenhuma opção encontrada"}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        colors: {
          ...theme.colors,
          primary25: "#0000001F",
          primary: "#0000001F",
        },
      })}
      styles={{
        
        control: (base) => ({
          ...base,
          minHeight: "40px",
          borderColor: "#0000001F",
          paddingLeft: 5,
          paddingRight: 5,
        }),
        valueContainer: (base) => ({
          ...base,
          flexWrap: 'wrap',
          padding: '8px',
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: '#D6D9E2',
          borderRadius: '50px',
          padding: '2px 6px',
          margin: '2px',
          color: '#0F1D42',
        }),
        multiValueLabel: (base) => ({
          ...base,
          color: '#0F1D42',
          padding: '3px 0px',
          fontSize: '12px',
          fontWeight: '300',
          
        }),
        multiValueRemove: (base) => ({
          ...base,
          color: '#0F1D42',
          ':hover': {
            backgroundColor: 'transparent',
            color: '#d32f2f',
          },
        }),
         option: (base, state) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent !important', 
          color: '#333 !important', 
          fontWeight: state.isSelected ? '600' : 'normal',
          '&:hover': {
            backgroundColor: '#f5f5f5 !important',
          },
        }),
      }}
    />
  );
};

export default InputSelectMultiCustom;